// extracted by mini-css-extract-plugin
export default {"sectionContainer":"policy_section_sectionContainer__haOlN"};